var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.demand)?_c(_vm.signTemplateComponent,{tag:"component",attrs:{"is-loading":_vm.isIframeContentLoading,"demand":_vm.demand,"signbook-error":_vm.signbookError,"signbook-url":_vm.signbookUrl,"signbook-token":_vm.signbookToken,"signbook-merchant-logo":_vm.signbookMerchantLogo,"nth-signbook":_vm.nthSignbook}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }